import React, { useRef, useEffect, useState } from "react";
import "./TabsComponent.scss";

const TabsComponent = ({
  tabsList = [],
  activeTab = "",
  onTabChange = () => {},
  isDisable = false,
}) => {
  const sliderRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(
    tabsList?.length > 6 ? true : false
  );
  const [showRightArrow, setShowRightArrow] = useState(
    tabsList?.length > 6 ? true : false
  );

  const checkForScrollPosition = () => {
    if (sliderRef.current) {
      const { scrollWidth, clientWidth, scrollLeft } = sliderRef.current;
      setShowLeftArrow(scrollLeft > 0);
      setShowRightArrow(scrollLeft + clientWidth < scrollWidth);
    }
  };

  const handleScroll = () => {
    checkForScrollPosition();
  };

  const handleLeftClick = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: -200, behavior: "smooth" });
    }
  };

  const handleRightClick = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: 200, behavior: "smooth" });
    }
  };

  useEffect(() => {
    checkForScrollPosition();
    if (sliderRef.current) {
      sliderRef.current.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (sliderRef.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        sliderRef.current.removeEventListener("scroll", handleScroll);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="tabs-container">
      <div className="tabs-wrapper">
        {showLeftArrow && (
          <div className="arrow left-arrow" onClick={handleLeftClick}>
            <img
              src="/chevron-right.svg"
              alt="Left Arrow"
              className="arrow-icon"
            />
          </div>
        )}
        <div className="tabs-list-wrapper">
          <div
            className={`tabs-list-comp ${
              tabsList?.length > 6 ? "more-tabs-list-comp" : ""
            }`}
            ref={sliderRef}
          >
            {tabsList.map((tab, index) => (
              <div
                key={`${index} ${tab.id}`}
                className={`tab-item ${activeTab === tab.id ? "active" : ""}`}
                onClick={() => {
                  if (!isDisable) onTabChange(tab.id);
                }}
              >
                <div
                  className="title-styles"
                  style={{ color: tab.id === activeTab ? "#1d2026" : "" }}
                >
                  {tab.label}
                </div>
              </div>
            ))}
          </div>
        </div>
        {showRightArrow && (
          <div className="arrow right-arrow" onClick={handleRightClick}>
            <img
              src="/chevron-right.svg"
              alt="Right Arrow"
              className="arrow-icon"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default TabsComponent;
